export default __webpack_public_path__ + "static/24-881ff90df8cf0a5b9b574ea94abe403e.png";